import { gql } from '@apollo/client';

// Centralized shared GraphQL queries and mutations

export const PRODUCT_DATA = gql`
  query ProductData($outlookId: String!, $product: [ProductSectorInput!], $country: [String!], $subregion: [SubregionInput!], $activity: [String!], $continuationToken: String, $limit: Int) {
    productData(outlookId: $outlookId, product: $product, country: $country, subregion: $subregion, activity: $activity, continuationToken: $continuationToken, limit: $limit) {
      metaData {
        totalCount
        requestCharge
        hasMoreResults
        continuationToken
      }
      data {
        id
        country
        subregion
        activity
        sector
        product
        year
        month
        value
        status
        fileName
        _ts
      }
    }
  }
`;

export const PRODUCT_COUNTS = gql`
  query countByProductSector {
    countByProductSector {
      product
      sector
      count
    }
  }
`;


export const COUNTRY_COUNTS = gql`
  query CountByCountry {
    countByCountry {
      country
      count
    }
  }
`;

export const ACTIVITY_COUNTS = gql`
  query CountByActivity {
    countByActivity {
      activity
      count
    }
  }
`;

export const FILENAME_COUNTS = gql`
  query CountByFilename {
    countByFilename {
      fileName
      recordCount
    }
  }
`;

export const COUNT_BY_DIMENSIONS = gql`
  query CountByDimensions {
    countByDimensions {
      product
      activity
      country
      sector
      subregion
      count
    }
  }
`;